import { useEffect, useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  DatePickerValue,
  DateRange,
  OneDateNavigator,
} from '@factorialco/f0-react/dist/experimental'

import { DateNavigatorConfig } from 'modules/ai_reports/components/DatasourceTypeRenderer/tableRendererRegistry'

type DateNavigationFilterProps = {
  config: DateNavigatorConfig
  onSelect: (value: DatePickerValue | undefined) => void
  value?: DatePickerValue | undefined
}

const normalizeDatePickerValue = (
  value: DateRange | Date | undefined
): Required<DateRange> | undefined => {
  if (!value) {
    return undefined
  }
  return value instanceof Date
    ? {
        from: value,
        to: value,
      }
    : {
        from: value.from,
        to: value.to ?? value.from,
      }
}

export const DateNavigationFilter = ({
  config: dateNavigatorConfig,
  value,
  onSelect,
}: DateNavigationFilterProps) => {
  const [localValue, setLocalValue] = useState<Required<DateRange> | undefined>(
    normalizeDatePickerValue(value?.value ?? dateNavigatorConfig.defaultValue)
  )

  useEffect(() => {
    setLocalValue(normalizeDatePickerValue(value?.value ?? dateNavigatorConfig.defaultValue))
  }, [value])

  const handleSelect = (value: DatePickerValue | undefined) => {
    setLocalValue(normalizeDatePickerValue(value?.value))
    onSelect?.(value)
  }

  return (
    <Box alignItems="flexEnd">
      {dateNavigatorConfig && (
        <OneDateNavigator
          value={{
            value: localValue,
            granularity: dateNavigatorConfig.granularity,
          }}
          granularities={[dateNavigatorConfig.granularity]}
          maxDate={dateNavigatorConfig.max}
          onSelect={handleSelect}
          hideGoToCurrent
        />
      )}
    </Box>
  )
}
